import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export interface AnswerDetail {
  answerName: string;
  isCorrect: boolean;
}

export interface QuestionDetail {
  questionName: string;
  quizId: number;
  answers: AnswerDetail[];
}

export interface QuestionListResponse {
  statusCode: number;
  isSuccess: boolean;
  result: QuestionDetail[];
}

const questionApi = createApi({
  reducerPath: "questionApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api",
    prepareHeaders: (Headers: Headers, api) => {
      const token = localStorage.getItem("token");
      token && Headers.append("Authorization", "Bearer " + token);
    },
  }),
  tagTypes: ["Question"],
  endpoints: (builder) => ({
    getQuestiones: builder.query<QuestionListResponse, void>({
      query: () => ({
        url: "Question",
      }),
      providesTags: ["Question"],
    }),
    getQuestionById: builder.query({
      query: (QuestionId) => ({
        url: `Question/${QuestionId}`,
      }),
      providesTags: ["Question"],
    }),
    getQuestionsByQuizId: builder.query({
      query: (quizId) => `Question/ByQuiz/${quizId}`,
      providesTags: ["Question"],
    }),
    createQuestion: builder.mutation({
      query: (formData) => ({
        url: "Question",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Question"],
    }),
    updateQuestion: builder.mutation({
      query: ({ data, id }) => ({
        url: `Question/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Question"],
    }),
    updateQuestionStatus: builder.mutation({
      query: ({ id, isActive }) => ({
        url: `Question/${id}/status`,
        method: "PATCH",
        body: { id, isActive },
      }),
      invalidatesTags: ["Question"],
    }),
    deleteQuestion: builder.mutation({
      query: ({ id }) => ({
        url: `Question/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Question"],
    }),
  }),
});

export const {
  useGetQuestionesQuery,
  useGetQuestionByIdQuery,
  useGetQuestionsByQuizIdQuery,
  useCreateQuestionMutation,
  useUpdateQuestionMutation,
  useUpdateQuestionStatusMutation,
  useDeleteQuestionMutation,
} = questionApi;
export default questionApi;
